import React from "react";
import PropTypes from "prop-types";

// PeriodCaption renders e.g. "month-to-date · day 9 of 30".
// The month/year is owned by the period dropdown above — not repeated here.
const PeriodCaption = ({ period, asOf }) => {
  const [y, m] = (period || "").split("-").map(Number);
  if (!y || !m) return null;
  const daysIn = new Date(y, m, 0).getDate();
  const now = asOf ? new Date(asOf) : new Date();
  let elapsed = now.getUTCFullYear() === y && now.getUTCMonth() + 1 === m ? now.getUTCDate() : daysIn;
  elapsed = Math.min(Math.max(elapsed, 1), daysIn);
  return (
    <div className="text-xs text-text-2">
      <span className="font-medium text-text">month-to-date</span> · day {elapsed} of {daysIn}
    </div>
  );
};

PeriodCaption.propTypes = { period: PropTypes.string, asOf: PropTypes.string };
export default PeriodCaption;
